module.exports = __webpack_public_path__ + "img/benefits_off.848d7b25.svg";